module.exports = __webpack_public_path__ + "static/media/power-hp5.c7ffeade.png";